import React from 'react';
import Slider from 'react-slick';

export default function AboutCarousel() {
  const slideContainerClasses = `px-3 outline-none`;
  const slideClasses = `h-60 w-full rounded-xl select-none outline-none`;
  const settings = {
    className: 'slider variable-width mb-8',
    style: { maxHeight: 240 },
    dots: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
  };
  return (
    <Slider {...settings}>
      <div style={{ width: 420 }} className={slideContainerClasses}>
        <div
          style={{
            backgroundImage: `url(/static/about/group/2.png)`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: 'center center',
          }}
          className={slideClasses}
        ></div>
      </div>
      <div style={{ width: 420 }} className={slideContainerClasses}>
        <div
          style={{
            backgroundImage: `url(/static/about/group/3.jpg)`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: 'center center',
          }}
          className={slideClasses}
        ></div>
      </div>
      <div style={{ width: 280 }} className={slideContainerClasses}>
        <div
          style={{
            backgroundImage: `url(/static/about/group/4.jpg)`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: 'center center',
          }}
          className={slideClasses}
        ></div>
      </div>
      <div style={{ width: 340 }} className={slideContainerClasses}>
        <div
          style={{
            backgroundImage: `url(/static/about/group/1.jpg)`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: 'center center',
          }}
          className={slideClasses}
        ></div>
      </div>
      <div style={{ width: 240 }} className={slideContainerClasses}>
        <div
          style={{
            backgroundImage: `url(/static/about/group/6.jpg)`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: 'center center',
          }}
          className={slideClasses}
        ></div>
      </div>
      <div style={{ width: 340 }} className={slideContainerClasses}>
        <div
          style={{
            backgroundImage: `url(/static/about/group/5.jpg)`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: 'center center',
          }}
          className={slideClasses}
        ></div>
      </div>
    </Slider>
  );
}
